import { useSubmitButton } from "@mongez/react-form";
import { Button, type ButtonProps } from "./Button";

type SubmitButtonProps = ButtonProps;

export function SubmitButton({ children, ...props }: SubmitButtonProps) {
  const { disabled, isSubmitting } = useSubmitButton();

  return (
    <Button
      {...props}
      type="submit"
      isLoading={isSubmitting}
      disabled={disabled || isSubmitting}
    >
      {children}
    </Button>
  );
}
